<template>
  <div class="messages-control" style="max-width: 330px; overflow: hidden; z-index: 120000">
    <transition-group name="list" mode="out-in" style="position: relative">
      <v-alert v-for="message in messages" 
        :key="message.id" :type="message.message_class" 
        @click="click_handler(message)" 
        style="width: 100%; max-width: 330px; cursor: pointer; white-space: pre-wrap; font-size: .8rem; user-select: none"
      >
        {{ formatMessagge(message) }}
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
import { eventBus } from '../../main';
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['messages'])
  },
  methods: {
    async click_handler(message){
      if(message.type === 0) return message.resolve()

      eventBus.$emit('dropOrder')
      if(Object.prototype.hasOwnProperty.call(message.message_data,'phones')) {
        let phone = message.message_data.phones.find(item => item.primary)
        
        await this.$store.dispatch('setGuest', message.message_data)
        await this.$store.dispatch('setPhone', phone)

        if(message.message_data.default_address) await this.$store.dispatch('setAddress', 
          message.message_data.addresses.find(item => item.id === message.message_data.default_address)
        )
      } else {
        this.$store.dispatch('setGuest', {
          addresses: [],
          phones: [],
          default_address: null,
          default_phone: null,
          anonymous: false,
          name: "",
          email: "",
          extra: "",
          black_list: false
        })
        await this.$store.dispatch('setPhone', message.message_data)
      }
      
      if(this.$route.path !== '/orders/new')  this.$router.push({path: '/orders/new'})
      return message.resolve()
    },

    formatMessagge(message){
      if(message.type === 0) return message.message_data

      // check phone dto or guest model
      if(Object.prototype.hasOwnProperty.call(message.message_data,'phones')) {
        let phone = message.message_data.phones.find(item => item.primary)
        return `Гость: ${message.message_data.name} \n Номер: ${phone.number}`
      } else {
        return `Номер: ${message.message_data.number}`
      }
    }
  }
}
</script>

<style>
.messages-control {
  display: flex;
  flex-direction: column-reverse;
  position: fixed;
  width: 300px;
  right: 0;
  top: auto;
  /* min-height: 100px; */
  bottom: 0px;
}

.list-move {
  transition: all 0.5s ease;
}
.list-enter-active {
  transition: all 0.5s ease;
  opacity: 0;
  transform: translateX(30px);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0px);
}

.list-leave-active {
  position: absolute;
  transition: all 0.5s ease;
  opacity: 1;
  transform: translateX(0px);
}

.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
/* .list-leave-active {
  position: absolute;
} */
</style>